module.exports = __webpack_public_path__ + "static/media/wizualizacja-40.adfe9320.png";